// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3ZzKA","footer":"ModalUpdate_footer__ujFkR"};